<template>
  <div class="search-page">
    <!-- 顶部搜索栏 -->
    <div class="search-header">
      <button class="search-header__back" @click="goBack">
        <svg class="search-header__back-icon" viewBox="0 0 24 24" width="22" height="22">
          <path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>返回</span>
      </button>
      <div class="search-header__input-wrap">
        <input
          v-model="keyword"
          class="search-header__input"
          type="text"
          placeholder="请输入关键字"
          @keyup.enter="onSearch"
        />
      </div>
      <button class="search-header__btn" @click="onSearch">搜索</button>
    </div>

    <!-- 搜索结果列表 -->
    <div class="search-result">
      <div v-if="loading" class="search-result__loading">加载中...</div>
      <template v-else>
        <div
          v-for="(item, idx) in results"
          :key="idx"
          class="search-result__item"
          @click="goDetail(item)"
        >
          <h3 class="search-result__title" v-html="highlight(item.title)"></h3>
          <p class="search-result__summary" v-html="highlight(item.summary || item.content)"></p>
          <div class="search-result__meta">
            <span>{{ item.author }}</span>
            <span>{{ formatTime(item.publishTime || item.createTime) }}</span>
            <span>来源：{{ item.source.split('|')[0] }}</span>
          </div>
        </div>
        <div v-if="!loading && results.length === 0 && searched" class="search-result__empty">
          未找到相关内容
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { searchNews } from '../../api/news';

export default {
  name: 'NewsSearch',
  data() {
    return {
      keyword: '',
      results: [],
      loading: false,
      searched: false
    };
  },
  created() {
    const query = this.$route.query.query || this.$route.query.q || '';
    if (query) {
      this.keyword = query;
      this.onSearch();
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async onSearch() {
      const query = this.keyword.trim();
      if (!query) {
        this.results = [];
        this.searched = false;
        return;
      }
      this.loading = true;
      this.searched = true;
      try {
        const res = await searchNews({ query });
        const data = res.data || {};
        const list = data.rows || data.list || data.records || data.data || [];
        this.results = list;
      } catch (err) {
        console.error('搜索失败:', err);
        this.results = [];
      } finally {
        this.loading = false;
      }
    },
    highlight(text) {
      if (!text) return '';
      const query = this.keyword.trim();
      if (!query) return this.escapeHtml(text);
      const escapedQuery = this.escapeRegExp(query);
      const reg = new RegExp(`(${escapedQuery})`, 'gi');
      return this.escapeHtml(text).replace(reg, '<span class="search-highlight">$1</span>');
    },
    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    formatTime(time) {
      if (!time) return '';
      if (typeof time === 'string' && time.length <= 19) return time;
      try {
        const d = new Date(time);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
      } catch (e) {
        return String(time);
      }
    },
    goDetail(item) {
      if (!item.newsCode && !item.id) return;
      this.$router.push(`/detail?newsCode=${item.newsCode || item.id}`);
    }
  }
};
</script>

<style scoped>
.search-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

/* 顶部搜索栏 */
.search-header {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
  background-color: #b0000b;
  box-sizing: border-box;
}

.search-header__back {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ffffff;
  font-size: 26px;
  background: transparent;
  border: none;
  padding: 8px 12px 8px 4px;
  margin-right: 12px;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;
}

.search-header__back:active {
  opacity: 0.6;
}

.search-header__back-icon {
  flex-shrink: 0;
}

.search-header__arrow {
  display: none;
}

.search-header__input-wrap {
  flex: 1;
  height: 64px;
  background-color: #ffffff;
  border-radius: 32px;
  overflow: hidden;
  padding: 0 24px;
  box-sizing: border-box;
}

.search-header__input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-size: 28px;
  color: #333333;
  background: transparent;
}

.search-header__input::placeholder {
  color: #999999;
}

.search-header__btn {
  width: 100px;
  height: 64px;
  margin-left: 20px;
  background-color: #ffffff;
  color: #b0000b;
  font-size: 28px;
  font-weight: 700;
  border: none;
  border-radius: 32px;
  cursor: pointer;
  flex-shrink: 0;
}

/* 搜索结果 */
.search-result {
  padding: 20px;
}

.search-result__loading,
.search-result__empty {
  text-align: center;
  padding: 80px 20px;
  font-size: 28px;
  color: #999999;
}

.search-result__item {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  cursor: pointer;
}

.search-result__title {
  margin: 0 0 16px;
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  line-height: 1.5;
}

.search-result__summary {
  margin: 0 0 16px;
  font-size: 26px;
  color: #666666;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.search-result__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 22px;
  color: #999999;
}

.search-result >>> .search-highlight {
  color: #b0000b;
  font-weight: 700;
}
</style>
